import { createSelector } from '@ngrx/store';

import { RelationShipWithDeceased, YesNoIDK } from '@features/succession/enums';
import {
  DeceasedMoreInformation,
  InheritanceInformation,
  NotaryInformation,
  ReporterInformation,
  TypeDocument,
} from '@features/succession/models';

import {
  selectDeceasedMoreInformation,
  selectInheritanceInformation,
  selectNotaryInformation,
  selectReporterInformation,
  selectSelfCareTypeDocuments,
} from './customer-information.selector';

const getFilename = (
  typeDocument?: string,
  typeDocuments?: TypeDocument[],
): TypeDocument[] | undefined =>
  typeDocuments?.filter((document) => document.typeDocument === typeDocument);

export const selectDataLayerDocuments = createSelector(
  selectDeceasedMoreInformation,
  selectSelfCareTypeDocuments,
  (deceasedMoreInformation?: DeceasedMoreInformation, typeDocuments?: TypeDocument[]): string =>
    (
      deceasedMoreInformation?.documents?.map((document) => {
        const type = document.typeDocument ? document.typeDocument : document.typology;
        const typeDocument = getFilename(type, typeDocuments);
        return typeDocument ? typeDocument[0].filename : '';
      }) || []
    ).join(', '),
);

export const selectDataLayerFuneralExpenses = createSelector(
  selectDeceasedMoreInformation,
  (deceasedMoreInformation?: DeceasedMoreInformation): string => {
    switch (deceasedMoreInformation?.hasFuneralContract) {
      case YesNoIDK.YES:
        return 'Prelevement frais obseques : Oui';
      case YesNoIDK.NO:
        return 'Prelevement frais obseques : Non';
      default:
        return 'Prelevement frais obseques : NSP';
    }
  },
);

export const selectDataLayerRelationshipWithDeceased = createSelector(
  selectReporterInformation,
  (reporterInformation?: ReporterInformation): string => {
    switch (reporterInformation?.relationshipWithDeceased) {
      case RelationShipWithDeceased.CHILD:
        return 'Relation avec defunt : Enfant';
      case RelationShipWithDeceased.SPOUSE:
        return 'Relation avec defunt : Conjoint';
      case RelationShipWithDeceased.OTHER_FAMILY_MEMBER:
        return 'Relation avec defunt : Autre membre de la famille';
      case RelationShipWithDeceased.NOTARY:
        return 'Relation avec defunt : Notaire';
      default:
        return 'Relation avec defunt : Autre tiers';
    }
  },
);

export const selectDataLayerHasNotary = createSelector(
  selectNotaryInformation,
  (notaryInformation?: NotaryInformation): string => {
    switch (notaryInformation?.hasNotary) {
      case YesNoIDK.YES:
        return 'Gestion sucession par notaire : Oui';
      case YesNoIDK.NO:
        return 'Gestion sucession par notaire : Non';
      default:
        return 'Gestion sucession par notaire : NSP';
    }
  },
);

export const selectDataLayerHasChildren = createSelector(
  selectInheritanceInformation,
  (inheritanceInformation?: InheritanceInformation): string => {
    switch (inheritanceInformation?.hasChild) {
      case YesNoIDK.YES:
        return 'Enfants defunt : Oui';
      case YesNoIDK.NO:
        return 'Enfants defunt : Non';
      default:
        return 'Enfants defunt : NSP';
    }
  },
);
